import Community from '@/models/community';
import axios from 'axios';

export class CommunitiesController {
    /**
     * Get the available list of communities
     *
     * @param void
     * @returns {Array|Error} An array of community models or an error object
     */
    static async index() {
        let response = axios
            .get('divisions/communities')
            .then((resp) => resp.data.map((company) => new Community(company)))
            .catch((error) => Promise.reject(error))
        return await response
    }

    /**
     * Get the community by ID
     *
     * @param int community The community ID number to look up
     * @returns {Array|Error} An array of community models or an error object
     */
    static async show(community) {
        let response = axios
            .get(`divisions/${community}`)
            .then((resp) => new Community(resp.data))
            .catch((error) => Promise.reject(error))
        return await response
    }
}